var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"home text-center",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-row',[_c('b-col',[_c('img',{staticStyle:{"width":"50%"},attrs:{"alt":_vm.company,"src":_vm.logoUrl}})])],1),_c('b-row',[_c('b-col',{domProps:{"innerHTML":_vm._s(_vm.welcome)}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }